import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-upsert-ppa-object-header',
  templateUrl: './upsert-ppa-object-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsertPPAObjectHeaderComponent {
  @Input() editMode: boolean = false;
}
